
export const SettingForm={
    id:"",
    director_name:"",
    director_phone:"",
    signature:"",
    role_for_professor:0,
    role_for_student:0,
    role_for_parent:0,
    school_id:""
}